// extracted by mini-css-extract-plugin
module.exports = {"table":"MDXComponents_table__0h0Ls","ul":"MDXComponents_ul__IBs4A","ol":"MDXComponents_ol__X1Zv0","section":"MDXComponents_section__eoXpG","callout":"MDXComponents_callout__Kj9Df"};